import { useParams } from '@tanstack/react-router';

import ManagedChat from '@/components/blocks/chat/managed-chat';
import { useOpen } from '@/hooks/use-open';
import { GiveFeedbackDialog } from '@/routes/(app)/(threads)/components/give-feedback-dialog';

const Thread = () => {
  const { open, onOpenChange, onOpenChangeWithValue, value } = useOpen<string>({
    defaultOpen: false,
  });
  const { threadId } = useParams({ from: '/app/threads/$threadId' });
  return (
    <>
      <ManagedChat onOpenFeedback={onOpenChangeWithValue} />
      {value && (
        <GiveFeedbackDialog
          threadId={threadId}
          messageId={value}
          open={open}
          onOpenChange={onOpenChange}
        />
      )}
    </>
  );
};

export default Thread;
